/**
 * Generic modal handler for PV dialogs (bulk enquiry, write a review).
 *
 * Markup contract:
 *   dialog  <dialog id="X" data-pv-modal>
 *   opener  <button data-pv-modal-open="X">
 *   closer  <button data-pv-modal-close>
 *   success <div data-pv-modal-success hidden>
 *
 * Uses a native <dialog>, so focus trapping, Escape-to-close and the backdrop
 * come from the browser rather than hand-rolled JS.
 *
 * Shopify's contact form does a real POST and redirects back with
 * ?contact_posted=true plus the form id as the fragment. The fragment is what
 * tells us which dialog to reopen, so the confirmation is actually seen rather
 * than hidden behind a closed dialog.
 */
(function () {
  'use strict';

  function wire(dialog) {
    var id = dialog.id;
    var closer = dialog.querySelector('[data-pv-modal-close]');

    function open() {
      if (typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
      else dialog.setAttribute('open', '');
      var first = dialog.querySelector('input, textarea, select');
      if (first) first.focus();
    }

    function close() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }

    document.querySelectorAll('[data-pv-modal-open="' + id + '"]').forEach(function (btn) {
      btn.addEventListener('click', open);
    });
    if (closer) closer.addEventListener('click', close);

    // Click on the backdrop, i.e. the dialog element itself outside its inner box.
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) close();
    });

    var form = dialog.querySelector('form');
    var success = dialog.querySelector('[data-pv-modal-success]');

    function showSuccess() {
      if (success) success.hidden = false;
      if (form) form.hidden = true;
    }

    /* Submit in the background so the confirmation appears in the dialog the
       person is already looking at, instead of throwing them to a new page.
       Shopify's contact endpoint answers with HTML and redirects on success,
       so success is detected from the final URL rather than a JSON body.
       Anything unexpected - a bot challenge, an outage - falls through to a
       normal submit so the browser can show whatever Shopify needs. */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var btn = form.querySelector('[type="submit"]');
        var label = btn ? btn.textContent : null;
        if (btn) {
          btn.disabled = true;
          btn.textContent = btn.getAttribute('data-sending') || 'Sending…';
        }

        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'text/html' }
        })
          .then(function (res) {
            if (res.ok && /contact_posted=true/.test(res.url)) {
              showSuccess();
              window.setTimeout(close, 2600);
              return;
            }
            form.submit();
          })
          .catch(function () {
            form.submit();
          })
          .finally(function () {
            if (btn) {
              btn.disabled = false;
              if (label !== null) btn.textContent = label;
            }
          });
      });
    }

    // A full-page post still happens on the fallback path, so honour the
    // redirect back and reopen this dialog to show its confirmation.
    var posted = /[?&]contact_posted=true/.test(window.location.search);
    var formId = form ? form.getAttribute('id') : null;
    if (posted && formId && window.location.hash === '#' + formId) {
      showSuccess();
      open();
      window.setTimeout(close, 2600);
    }
  }

  function init() {
    document.querySelectorAll('[data-pv-modal]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
